// Plain-English messages for refused catalogue saves (SOPS-169). The codes come
// from contracts/catalogue-admin-api.md in station-ops'
// specs/SOPS-169-catalogue-eround-mapping and arrive as `error_code` on
// account-management's ErrorResponse. `message` is engineering text and is never shown.

const MESSAGES: Record<string, string> = {
  WALLBOX_NOT_MAPPED:
    "This model can only be shown to customers once eRound can set it up: add its eRound manufacturer, model and charging points first.",
  WALLBOX_MAPPING_INVALID:
    "The eRound mapping is incomplete: fill in the eRound manufacturer, model and charging points (at least 1).",
};

export const wallboxCatalogueErrorMessage = (err: any, fallback: string): string => {
  const code = err?.response?.data?.error_code;
  if (typeof code === "string" && MESSAGES[code]) return MESSAGES[code];
  return fallback;
};

/** Plain words for a code the bulk import returns per line. */
export const wallboxCatalogueCodeMessage = (code: string): string =>
  MESSAGES[code] ?? `Refused (${code}).`;
